/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CriteriaCategory } from './CriteriaCategory';
import {
    CriteriaCategoryFromJSON,
    CriteriaCategoryFromJSONTyped,
    CriteriaCategoryToJSON,
} from './CriteriaCategory';

/**
 * 
 * @export
 * @interface CreateCriteriaCategory201Response
 */
export interface CreateCriteriaCategory201Response {
    /**
     * 
     * @type {CriteriaCategory}
     * @memberof CreateCriteriaCategory201Response
     */
    data?: CriteriaCategory;
}

/**
 * Check if a given object implements the CreateCriteriaCategory201Response interface.
 */
export function instanceOfCreateCriteriaCategory201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateCriteriaCategory201ResponseFromJSON(json: any): CreateCriteriaCategory201Response {
    return CreateCriteriaCategory201ResponseFromJSONTyped(json, false);
}

export function CreateCriteriaCategory201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCriteriaCategory201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CriteriaCategoryFromJSON(json['data']),
    };
}

export function CreateCriteriaCategory201ResponseToJSON(value?: CreateCriteriaCategory201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CriteriaCategoryToJSON(value.data),
    };
}

